module.exports = __webpack_public_path__ + "static/media/lucareers_logo.a3e99d20.png";